var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPyrotechnics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 4.00118C16.2764 4.00118 3.93739 16.5379 3.93739 32C3.93739 47.4622 16.2764 59.9989 31.5 59.9989C46.7236 59.9989 59.0626 47.4622 59.0626 32C59.0626 16.5379 46.7236 4.00118 31.5 4.00118ZM0.00012207 32C0.00012207 14.3251 14.1043 -0.00109863 31.5 -0.00109863C48.8957 -0.00109863 62.9999 14.3251 62.9999 32C62.9999 49.675 48.8957 64.0012 31.5 64.0012C14.1043 64.0012 0.00012207 49.675 0.00012207 32Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.301 55.6377L7.91235 11.2857L10.7042 8.46356L54.0928 52.8155L51.301 55.6377Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3689 48.72H31.8176C31.7451 48.72 31.6864 48.7797 31.6864 48.8533V53.8933C31.6864 53.9669 31.7451 54.0266 31.8176 54.0266H32.3689C32.4414 54.0266 32.5001 53.9669 32.5001 53.8933V48.8533C32.5001 48.7797 32.4414 48.72 32.3689 48.72Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5541 46.8896L36.2932 47.1894C36.2164 47.2777 36.2246 47.4126 36.3115 47.4906L39.9116 50.7231C39.9986 50.8011 40.1313 50.7928 40.2081 50.7045L40.469 50.4047C40.5458 50.3164 40.5376 50.1815 40.4507 50.1035L36.8506 46.871C36.7636 46.793 36.6309 46.8013 36.5541 46.8896Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7247 50.3896L24.0204 50.7294C24.0876 50.8067 24.2037 50.814 24.2798 50.7457L27.9193 47.4779C27.9953 47.4096 28.0025 47.2916 27.9353 47.2143L27.6397 46.8745C27.5724 46.7973 27.4563 46.79 27.3802 46.8583L23.7407 50.1261C23.6647 50.1944 23.6575 50.3124 23.7247 50.3896Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6464 43.36V44.88H37.6188V35.4933L26.6464 43.36Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6464 35.7333V41.0133L37.6188 33.12V27.84L26.6464 35.7333Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7975 20.32L32.1325 11.9733L24.415 20.3733L26.6463 20.3467V25.7067L34.285 20.32H37.5138L26.6463 28.1067V33.3867L37.7238 25.44V20.32H39.7975Z",
    fill: "#123660"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPyrotechnics);
export default __webpack_public_path__ + "static/media/icon-pyrotechnics.4f5ff6a84baf0273362d7598f7a61219.svg";
export { ForwardRef as ReactComponent };